/**
 * Capability 模块错误码
 */
export const ErrorCodes = {
  /** 成功 */
  SUCCESS: '0',
  /** 能力不存在 */
  CAPABILITY_NOT_FOUND: 'k_ec_cap_001',
  /** 插件不存在 */
  PLUGIN_NOT_FOUND: 'k_ec_cap_002',
  /** Action 不存在 */
  ACTION_NOT_FOUND: 'k_ec_cap_003',
  /** 参数验证失败 */
  PARAMS_VALIDATION_ERROR: 'k_ec_cap_004',
  /** 执行失败 */
  EXECUTION_ERROR: 'k_ec_cap_005',
  /** 计费受限 */
  RATE_LIMIT_EXCEEDED: 'k_ec_cap_006',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
